// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import type { CycleTimeReportFilter } from '@/report/api/types';
import { outboundShipmentCycleTimeReportSchema } from '@/shipment/api/types';
import { serializeDateForAPI } from '@/utilities/date-time';
import queryString from 'query-string';
import { z } from 'zod';

const outboundShipmentCycleTimeReportResponseSchema = z.object({
  data: outboundShipmentCycleTimeReportSchema,
  metadata: responseMetadataSchema,
});

type OutboundShipmentCycleTimeReportResponse = z.infer<
  typeof outboundShipmentCycleTimeReportResponseSchema
>;

export function serializeOutboundShipmentCycleTimeReportFilter(
  filter?: CycleTimeReportFilter
): string {
  if (!filter) {
    return '';
  }

  return queryString.stringify({
    startDate: serializeDateForAPI(filter.interval.start),
    endDate: serializeDateForAPI(filter.interval.end),
  });
}

export async function getOutboundShipmentCycleTimeReport(
  filter?: CycleTimeReportFilter
): Promise<OutboundShipmentCycleTimeReportResponse> {
  const url = '/v1/report/shipment/outbound/cycle-time';
  const response = await api.get(url, {
    paramsSerializer: (parameters) => queryString.stringify(parameters),
    params: {
      startDate: serializeDateForAPI(filter?.interval.start),
      endDate: serializeDateForAPI(filter?.interval.end),
    },
  });

  return parseResponse(
    outboundShipmentCycleTimeReportResponseSchema,
    response.data,
    {
      schemaName: 'OutboundShipmentCycleTimeReport',
      endpoint: url,
    }
  );
}
